<template>
  <PageBreadcrumb
    :crumbs="[{
      link: '/aste/',
      label: 'Gestione Aste'
    }, {
    
      link: '/aste/' + auctionId + '/allegati',
      label: 'Gestione Allegati ' + auction.name
    }, {
      label: 'Carica Allegato'
    }]"
  />

  <form autocomplete="off">
    <InputText
      v-model="form.description"
      :error-fields="errorFields"
      name="description"
      :submitted="submitted"
    >
      Descrizione
    </InputText>

    <InputFile 
      v-model="form.document"
      :error-fields="errorFields"
      name="document"
      :submitted="submitted"
    >
      Documento
    </InputFile>

    <SubmitButtons
      :create-and-back="createAndBack"
      :create-and-stay="createAndStay"
      :mode="form.uuid ? 'update' : 'create'"
      :pending="pending"
      :update-and-back="updateAndBack"
      :update-and-stay="updateAndStay"
    />
  </form>
</template>

<script setup>
import { reactive, ref } from "vue";
import { useRoute } from 'vue-router';

import InputFile from "@/components/form/InputFile.vue";
import InputText from "@/components/form/InputText.vue";
import SubmitButtons from "@/components/form/SubmitButtons.vue";
import PageBreadcrumb from "@/components/PageBreadcrumb.vue";
import useAxios from "@/composables/axios";
import useForm from "@/composables/form";

const props = defineProps({
  id: {
    required: false,
    type: String,
    default: null
  },
});

const axios = useAxios();
const route = useRoute()

const auctionId = route.params.auctionId
const auctionResp = await axios.get('/auction/' + auctionId);
const auction = ref(auctionResp.data);

let form = reactive({
  description: null,
  document: null
});

const rules = {
  description: {
    type: "string",
    max: 128,
    required: true,
  },
  document: {
    type: "any",
    required: true
  }
};

const { submitted, pending, errorFields, createAndBack, createAndStay, updateAndBack, updateAndStay } = useForm(form, 'auction-attachment/' + auctionId, rules, {
  create: 'Asta creata con successo',
  update: 'Asta modificata con successo'
}, '/aste/' + auctionId + '/allegati', () => {
  form.description = null;
  form.document = null;
}, true)

</script>
